// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3uGOIsZtfmdS2fRJ7jHtgU","icon":"x3oeGO_z40HQTW4KXt5Tt","active":"_15arRepUGsFjbTzTcLSih0"};